/**
 *  ZoneBar script file
**/
import filters from '@/filters/customFormatters'

export default {
  name: 'ZoneBar',
  mixins: [filters],
  components: {},
  props: {
    zone: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  methods: {
  }
}
